'use strict';

var PromiseLib = require('../utils/promise');

function setValue(key, value, overwrite) {
  if (overwrite === undefined) {
    // only avoid overwrite if explicitly disabled
    overwrite = true;
  }

  switch (key.toLowerCase()) {
    case 'promise':
      if (!overwrite && PromiseLib.Promise) return;
      PromiseLib.Promise = value;
      break;

    default:
      break;
  }
}

module.exports = setValue;
//# sourceMappingURL=set-value.js.map



//////////////////
// WEBPACK FOOTER
// ./~/exceljs/dist/es5/config/set-value.js
// module id = 1425
// module chunks = 0